import {
	COMPONENT_STATES,
	COMPONENT_TYPE as TYPE,
	DEFAULT_MEDIA_QUERY_PLATFORMS,
	UNIFORM_PROPS,
} from 'common/constants';
import { getText } from 'common/utils/dictionary';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Fields/TextAreaField/TextArea';
import { FIELD_BB_ERROR_TYPE, FIELD_BB_STYLE } from '../constants';

/**
 * @param options {Object=}
 * @param options.dictionary {Object=}
 * @returns {{ view, model }}
 * @constructor
 */
export const TEXT_AREA_FIELD = (options = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.TEXT_AREA_FIELD;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: TEXT_AREA_FIELD.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
						[UNIFORM_PROPS.fieldErrorShow]: FIELD_BB_ERROR_TYPE.required,
					},

					componentProps: {
						[UNIFORM_PROPS.fieldPlaceholder]: getText(
							// @ts-expect-error ts-migrate FIXME
							options.dictionary,
							type,
							UNIFORM_PROPS.fieldPlaceholder
						),
						// [UNIFORM_PROPS.fieldError]: {
						// 	// [FIELD_BB_ERROR_TYPE.REQUIRED]: 'required',
						// 	// ...
						// },
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									[FIELD_BB_STYLE.TEXT.PH_COLOR]: 'rgba(0, 0, 0, 0.54)',
								},
							},
						},
						other: {
							// 	[COMPONENT_STATES.DEFAULT]: {
							// 		[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
							// 			// ...
							// 		},
							// 	},
						},
					},
					nodeProps: {
						id: generateNodeId(_id, TEXT_AREA_FIELD.displayName),
					},
				},
				children: [],
			};
		},
	};
};

TEXT_AREA_FIELD.displayName = 'TextAreaField';
